import React, { ReactNode } from 'react'
import { Tile } from './tile'
import { CircleChecked } from 'app/assets/icons'

type Props = {
    id: string,
    price?: number,
    priceExtra?: number,
    onTileSelected?: (idProduct: string, isSelected: boolean) => void,
    sizeName?: string,
    isSelected?: boolean,
    isFromCart?: boolean,
    image?: ReactNode,
    selectableSizeName?: string
}

const SelectableSizeTile = (props: Props) => {
    const {
        price,
        priceExtra,
        id,
        onTileSelected,
        sizeName,
        isSelected,
        isFromCart,
        selectableSizeName,
        image,
        ...rest
    } = props
    return (
        <Tile
            id={id}
            price={price}
            priceExtra={priceExtra}
            image={image}
            selectableSizeName={selectableSizeName}
            onTileSelected={onTileSelected}
            IconTopRight={CircleChecked}
            isSelected={isSelected}
            isFromCart={isFromCart}
            {...rest}
        />
    )
}

export { SelectableSizeTile }
